import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    // Update page title and meta tags
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    document.title = '合同会社Lill - AIで未来を、今日から実現する | AI導入支援・システム開発';
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '合同会社Lillは、AIアシスタントサービス「teal」の運営、AI活用設計・導入コンサル、ホームページ制作、システム開発、IT運用支援、web3プロジェクト支援を提供するAI企業です。最先端のAI技術で企業のDXを加速させます。');
    }

    // Update keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'teal,AI導入支援,Open Claw,AI活用設計,ホームページ制作,システム開発,IT運用支援,web3,合同会社Lill,東京都清瀬市');
    }

    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', siteUrl + '/');
    }

    // Update OG tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '合同会社Lill - AIで未来を、今日から実現する | AI導入支援・システム開発');
    }

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '合同会社Lillは、AIアシスタントサービス「teal」の運営、AI活用設計・導入コンサル、ホームページ制作、システム開発、IT運用支援、web3プロジェクト支援を提供するAI企業です。最先端のAI技術で企業のDXを加速させます。');
    }

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('href', siteUrl + '/');
    }

    // Schema.org JSON-LD
    const schemaWebSite = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '合同会社Lill',
      url: siteUrl,
      description: 'AIアシスタントサービス「teal」の運営をはじめ、AI活用設計・導入コンサル、ホームページ制作、システム開発、IT運用支援、web3プロジェクト支援を提供するAI企業。',
      publisher: {
        '@type': 'Organization',
        name: '合同会社Lill',
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      }
    };

    const schemaOrganization = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '合同会社Lill',
      url: siteUrl,
      logo: `${siteUrl}/logo.png`,
      description: 'AIアシスタントサービス「teal」の運営、AI活用設計・導入コンサル、ホームページ制作、システム開発、IT運用支援、web3プロジェクト支援を提供するAI企業。最先端のAI技術で企業のDXを加速させます。',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'JP',
        addressRegion: '東京都',
        addressLocality: '清瀬市',
        streetAddress: '下宿2丁目439-3'
      },
      foundingDate: '2025-03',
      founder: {
        '@type': 'Person',
        name: '小幡 和希'
      },
      sameAs: [
        'https://teal-me.io/'
      ]
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(schemaWebSite);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(schemaOrganization);
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/69aaa498e03102de88e73614aeed548f.jpg"
            alt="都市風景"
            className="w-full h-full object-cover object-center"
          />
          {/* Dark Navy Overlay */}
          <div className="absolute inset-0 bg-[#1a2744]/60"></div>
        </div>

        {/* Hero Content */}
        <div className={`absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4 sm:px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="text-2xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight sm:whitespace-nowrap">
            テクノロジーで、ビジネスの"次"をつくる。
          </h1>
          <p className="text-base sm:text-xl text-white/90 mb-8 sm:mb-12">
            AIとITの力で、事業を加速させるパートナー
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center items-center w-full">
            <Link
              to="/service"
              className="w-4/5 sm:w-auto px-10 py-4 bg-white text-[#1a2744] font-semibold rounded-md hover:bg-gray-100 transition-all duration-300 whitespace-nowrap"
            >
              サービスを見る
            </Link>
            <Link
              to="/contact"
              className="w-4/5 sm:w-auto px-10 py-4 bg-[#1a2744] text-white font-semibold rounded-md hover:bg-[#0f1829] transition-all duration-300 whitespace-nowrap"
            >
              お問い合わせ
            </Link>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1a2744] text-center mb-16">
            事業内容
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Service Card 1 */}
            <div className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-all duration-300 flex flex-col">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-robot-line text-5xl text-[#2563EB]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a2744] mb-4">
                AIアシスタント「Teal」の運営
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-1" style={{wordBreak:'keep-all',overflowWrap:'anywhere'}}>
                選ぶだけで、自動化完了。
AIに聞く時代から、AIが聞いてくる時代へ。
              </p>
              <a
                href="https://teal-me.io/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-[#2563EB] font-semibold hover:underline mt-auto"
              >
                詳しく見る
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>

            {/* Service Card 2 */}
            <div className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-all duration-300 flex flex-col">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-lightbulb-line text-5xl text-[#2563EB]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a2744] mb-4">
                AI活用コンサルティング
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-1" style={{wordBreak:'keep-all',overflowWrap:'anywhere'}}>
                ChatGPT・Claude等の業務導入設計からデータ分析まで。
              </p>
              <Link
                to="/service#ai-consulting"
                className="inline-flex items-center text-[#2563EB] font-semibold hover:underline mt-auto"
              >
                詳しく見る
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>

            {/* Service Card 3 */}
            <div className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-all duration-300 flex flex-col">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-window-line text-5xl text-[#2563EB]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a2744] mb-4">
                サクッとHP
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-1" style={{wordBreak:'keep-all',overflowWrap:'anywhere'}}>
                月額3,980円〜のHP制作。
              </p>
              <a
                href="https://sakuhp.readdy.co/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-[#2563EB] font-semibold hover:underline mt-auto"
              >
                詳しく見る
                <i className="ri-external-link-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Works Pickup Section */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1a2744] text-center mb-16">
            実績紹介
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Work Card 1 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=artificial%20intelligence%20AI%20platform%20interface%20dashboard%20with%20modern%20clean%20design%20showing%20automation%20and%20workflow%20optimization%20tools%20in%20professional%20business%20environment&width=600&height=400&seq=work-openclaw-001&orientation=landscape"
                  alt="Open Claw導入支援"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-sm font-semibold rounded-full mb-3">
                  AI導入支援
                </span>
                <h3 className="text-xl font-bold text-[#1a2744] mb-3">
                  Open Claw導入支援
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  企業へのOpen Claw導入を支援。業務プロセスの効率化と生産性向上を実現しました。
                </p>
              </div>
            </div>

            {/* Work Card 2 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=construction%20architecture%20data%20management%20system%20interface%20showing%20building%20blueprints%20project%20management%20dashboard%20with%20clean%20professional%20design%20and%20organized%20data%20visualization&width=600&height=400&seq=work-construction-002&orientation=landscape"
                  alt="建築業データ管理システム構築"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-green-100 text-green-700 text-sm font-semibold rounded-full mb-3">
                  システム開発
                </span>
                <h3 className="text-xl font-bold text-[#1a2744] mb-3">
                  建築業データ管理システム構築
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  建築業界特有の業務フローに合わせたデータ管理システムをフルスクラッチで構築しました。
                </p>
              </div>
            </div>

            {/* Work Card 3 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20responsive%20website%20design%20showcase%20on%20multiple%20devices%20laptop%20tablet%20smartphone%20showing%20clean%20professional%20business%20homepage%20with%20minimalist%20layout%20and%20elegant%20typography&width=600&height=400&seq=work-website-003&orientation=landscape"
                  alt="サクッとHP"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-orange-100 text-orange-700 text-sm font-semibold rounded-full mb-3">
                  HP制作
                </span>
                <h3 className="text-xl font-bold text-[#1a2744] mb-3">
                  サクッとHP — 契約5社
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  福祉業界・飲食業界を中心に、低コスト・高品質なHP制作を提供。5社の導入実績があります。
                </p>
              </div>
            </div>
          </div>

          {/* More Works Button */}
          <div className="text-center">
            <Link
              to="/works"
              className="inline-flex items-center px-8 py-3 bg-white text-[#1a2744] font-semibold rounded-md border border-gray-300 hover:bg-gray-50 transition-all duration-300 whitespace-nowrap"
            >
              実績をもっと見る
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Note Blog Section */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1a2744] text-center mb-6">
            ブログ
          </h2>
          <p className="text-center text-gray-600 mb-16">
            AI活用の実践的な情報をnoteで発信しています
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Blog Card 1 */}
            <a
              href="https://note.com/ai_kaishainda/n/ncd73fed343cf"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 block"
            >
              <div className="h-48">
                <img
                  src="https://static.readdy.ai/image/a547e5108220e49fc6552e81382cf2b5/b7ea67f33ec0230c22a5f5c8ee8e4bf9.png"
                  alt="AI活用ブログ"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-[#1a2744] mb-3">
                  AI活用の最新トレンド
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  ビジネスにおけるAI活用の最新情報と実践的なノウハウをお届けします。
                </p>
              </div>
            </a>

            {/* Blog Card 2 */}
            <a
              href="https://note.com/ai_kaishainda/n/n9f286bb0e265"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 block"
            >
              <div className="h-48">
                <img
                  src="https://static.readdy.ai/image/a547e5108220e49fc6552e81382cf2b5/6efbf6ae5a8c195abca21353d07973d3.png"
                  alt="テクノロジーブログ"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-[#1a2744] mb-3">
                  業務効率化のヒント
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  テクノロジーを活用した業務改善の具体的な方法を紹介します。
                </p>
              </div>
            </a>

            {/* Blog Card 3 */}
            <a
              href="https://note.com/ai_kaishainda/n/n47f7dccd2c58"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 block"
            >
              <div className="h-48">
                <img
                  src="https://static.readdy.ai/image/a547e5108220e49fc6552e81382cf2b5/5385a5f9943d2e44f97678ec2e445496.png"
                  alt="コンサルティングブログ"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-[#1a2744] mb-3">
                  導入事例と成功のポイント
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  実際の導入事例から学ぶ、成功のためのポイントを解説します。
                </p>
              </div>
            </a>
          </div>

          {/* Note Button */}
          <div className="text-center">
            <a
              href="https://note.com/ai_kaishainda"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-3 bg-white text-[#1a2744] font-semibold rounded-md border border-gray-300 hover:bg-gray-50 transition-all duration-300 whitespace-nowrap"
            >
              noteを読む
              <i className="ri-external-link-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 bg-[#1a2744]">
        <div className="w-full flex flex-col items-center justify-center text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8">
            まずはお気軽にご相談ください。
          </h2>
          <div className="flex justify-center w-full">
            <Link
              to="/contact"
              className="px-12 py-4 bg-white text-[#1a2744] font-semibold rounded-md hover:bg-gray-100 transition-all duration-300 whitespace-nowrap"
            >
              無料で相談する
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}